module.exports = __webpack_public_path__ + "media/videos/home/hero-h265-5eef25f6abe07002e726df60dab5fb3f.mp4";